module.exports = __webpack_public_path__ + "img/1571365393.a1dc7f52.jpg";